webpackJsonp([1],{

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(620)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = exportChartConfigToCsv;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

function exportChartConfigToCsv(chartConfig) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'chart-data.csv';
  var delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ';';
  var customHeader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var labels = chartConfig.data.labels;
  var datasets = chartConfig.data.datasets;

  if (!labels || !datasets || !labels.length) {
    console.warn('ChartConfig sem dados suficientes.');
    return;
  }

  var header = customHeader ? customHeader.join(delimiter) : ['Label'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(datasets.map(function (ds) {
    return ds.label;
  }))).join(delimiter);

  var linhas = labels.map(function (lbl, i) {
    var valores = datasets.map(function (ds) {
      var val = ds.data[i];

      if (typeof val === 'number') {
        return val.toLocaleString('pt-BR');
      }
      return val;
    });
    return [lbl].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(valores)).join(delimiter);
  });

  var csvContent = '\uFEFF' + [header].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(linhas)).join('\n');

  var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  var url = URL.createObjectURL(blob);

  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(691);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd032021',
  loginNameProject: 'BIODIGESTOR RENU JACAREZINHO',
  sideNameProject: 'BIO RENU JACAREZINHO',
  exibirGraficoInicial: false,
  iconeInterno: '../static/img/logo_renu_jacarezinho.svg',
  grafico: {
    parametro: 'BiodigestorVazaoAcumulada',
    titulo: 'Gás consumido a partir do dia',
    label: 'Gás consumido (m³)'
  },
  idioma: 'Pt-Br'
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(34);



if (window.localStorage.getItem('token')) {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
}

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = 'https://mpsolidtec.com.br/mpcontrolebio/public/api/v1/' + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].project;
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

window.axios = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_GraficosGerais_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_GraficosGerais_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_GraficosGerais_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue__);












var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/logout',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default.a,
    name: 'Principal',
    meta: {
      namePtBr: 'Principal',
      nameEs: 'Principal',
      nameEn: 'Home',
      nameDe: 'Hauptsächlich',
      descriptionPtBr: 'Monitoramento do Biodigestor',
      descriptionEs: 'Monitoreo de biodigestores',
      descriptionEn: 'Biodigester Monitoring',
      descriptionDe: 'Biodigester-Überwachung',
      requiresAuth: true
    }
  }, {
    path: 'usuario',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue___default.a,
    name: 'Usuário',
    meta: {
      namePtBr: 'Usuário',
      nameEs: 'Usuario',
      nameEn: 'User',
      nameDe: 'Nutzer',
      descriptionPtBr: 'Edição dos dados de Usuário',
      descriptionEs: 'Editar datos de usuario',
      descriptionEn: 'Editing User Data',
      descriptionDe: 'Benutzerdaten bearbeiten',
      requiresAuth: true
    }
  }, {
    path: 'manutencao',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue___default.a,
    name: 'Manutenção',
    meta: {
      namePtBr: 'Manutenção',
      nameEs: 'Mantenimiento',
      nameEn: 'Maintenance',
      nameDe: 'Wartung',
      descriptionPtBr: 'Monitoramento de todas variáveis do Biodigestor',
      descriptionEs: 'Seguimiento de todas las variables del biodigestor',
      descriptionEn: 'Monitoring of all Biodigester variables',
      descriptionDe: 'Überwachung aller Biodigester-Variablen',
      requiresAuth: true
    }
  }, {
    path: 'graficos-acumulados',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue___default.a,
    name: 'Gráficos Acumulados',
    meta: {
      namePtBr: 'Gráficos Acumulados',
      nameEs: 'Gráficos acumulados',
      nameEn: 'Accumulated Charts',
      nameDe: 'Akkumulierte Charts',
      descriptionPtBr: 'Relatório dos valores acumulados',
      descriptionEs: 'Informe de valores acumulados',
      descriptionEn: 'Accumulated Values ​​Report',
      descriptionDe: 'Bericht der kumulierten Werte',
      requiresAuth: true
    }
  }, {
    path: 'graficos-gerais',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_GraficosGerais_vue___default.a,
    name: 'Gráficos Gerais',
    meta: {
      namePtBr: 'Gráficos Gerais',
      nameEs: 'Gráficos generales',
      nameEn: 'General Graphics',
      nameDe: 'Allgemeine Grafiken',
      descriptionPtBr: 'Relatório das variáveis não acumuladas do Biodigestor',
      descriptionEs: 'Informe de variables no acumuladas del biodigestor',
      descriptionEn: 'Biodigester non-accumulated variables report',
      descriptionDe: 'Bericht zu nicht akkumulierten Variablen des Biodigesters',
      requiresAuth: true
    }
  }, {
    path: 'graficos-material',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue___default.a,
    name: 'Gráficos Material',
    meta: {
      namePtBr: 'Gráficos Material',
      nameEs: 'Gráficos de materiales',
      nameEn: 'Material Graphics',
      nameDe: 'Materialgrafiken',
      descriptionPtBr: 'Valores registrados da análise do material do biodigestor',
      descriptionEs: 'Valores registrados a partir del análisis del material biodigestor',
      descriptionEn: 'Values ​​recorded from the analysis of the biodigester material',
      descriptionDe: 'Erfasste Werte aus der Analyse des Biovergärungsmaterials',
      requiresAuth: true
    }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules__ = __webpack_require__(161);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: __WEBPACK_IMPORTED_MODULE_5__modules__["default"]
}));

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(312);


var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase__["a" /* default */].initializeApp({
  apiKey: 'AIzaSyAExn1UpSdJanCXpmAyRPb8jWL5fgyHZKo',
  authDomain: 'controle-biodigestor.firebaseapp.com',
  databaseURL: 'https://controle-biodigestor.firebaseio.com',
  projectId: 'controle-biodigestor',
  storageBucket: 'controle-biodigestor.appspot.com',
  messagingSenderId: '200358044541'
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_paginate__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_alertify__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__axios__ = __webpack_require__(435);














__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_6__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_6__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_6__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_6__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuefire__["a" /* rtdbPlugin */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue2_filters___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_paginate___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__["a" /* BootstrapVue */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue__["b" /* IconsPlugin */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_alertify__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}



new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__components_App_vue___default.a);
  }
});

window.bugsnagClient = window.bugsnag('02fe1c2caaf5874c50b6ee19534f5932');
window.bugsnagClient.use(window.bugsnag__vue(__WEBPACK_IMPORTED_MODULE_1_vue__["default"]));

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  acumulados: {},
  gerais: {},
  material: {},
  setedias: {}
};

var mutations = {
  fillDataAcumulados: function fillDataAcumulados(state, res) {
    state.acumulados = res.data;
    console.log(res);
  },
  fillDataGerais: function fillDataGerais(state, res) {
    state.gerais = res.data;
  },
  fillDataMaterial: function fillDataMaterial(state, res) {
    state.material = res.data;
  },
  fillDataSeteDias: function fillDataSeteDias(state, res) {
    state.setedias = res.data;
  }
};

var actions = {
  createGraficoGerais: function createGraficoGerais(context, data) {
    var qs = __webpack_require__(90);
    data = qs.stringify(data);
    return window.axios.post('/relatorios', data).then(function (res) {
      context.commit('fillDataGerais', res);
      return res;
    });
  },
  createGraficoSeteDias: function createGraficoSeteDias(context, data) {
    var qs = __webpack_require__(90);
    data = qs.stringify(data);
    return window.axios.post('/relatorios/setedias', data).then(function (res) {
      context.commit('fillDataSeteDias', res);
      return res;
    });
  },
  createGraficoMateriais: function createGraficoMateriais(context, data) {
    var qs = __webpack_require__(90);
    data = qs.stringify(data);
    return window.axios.post('/relatorios', data).then(function (res) {
      context.commit('fillDataMaterial', res);
      return res;
    });
  },
  createGraficoAcumulados: function createGraficoAcumulados(context, data) {
    var qs = __webpack_require__(90);
    data = qs.stringify(data);
    return window.axios.post('/relatorios/dias', data).then(function (res) {
      context.commit('fillDataAcumulados', res);
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  }
});

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{
      id: 1,
      title: 'Support Team',
      body: 'Why not consider this a test message?',
      createdAt: '17 min ago'
    }],
    notifications: [{
      id: 1,
      title: 'Birthday Reminder',
      body: 'Today is Brians birthday.',
      createdAt: 'just now',
      readAt: null
    }, {
      id: 2,
      title: 'Bank Holiday in London',
      body: 'Our office in London has a bank holiday today. Do not expect them to answer the phone.',
      createdAt: '4 hours ago',
      readAt: null
    }, {
      id: 3,
      title: 'Birthday Reminder',
      body: 'Today is Christians birthday.',
      createdAt: '27 days ago',
      readAt: '2018-08-12 00:00:00'
    }, {
      id: 4,
      title: 'Birthday Reminder',
      body: 'Today is Tanjas birthday.',
      createdAt: '29 days ago',
      readAt: '2018-08-12 00:00:00'
    }, {
      id: 5,
      title: 'Sales Bonus received',
      body: 'You received your monthly sales bonus of 3%. This month you made $2,700 extra!',
      createdAt: '7 hours ago',
      readAt: null
    }],
    tasks: []
  }
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_DashFooter__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_DashFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__layout_DashFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashHeader__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_DashHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hideseek__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hideseek__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    DashFooter: __WEBPACK_IMPORTED_MODULE_1__layout_DashFooter___default.a,
    DashHeader: __WEBPACK_IMPORTED_MODULE_2__layout_DashHeader___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default.a
  },
  data: function data() {
    return {
      idioma: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].idioma,
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].hideLogoOnMobile
      }
    };
  },
  computed: {
    user: function user() {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].iconeInterno,
        email: this.$store.state.user.email
      };
    }
  }
});

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(34);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      email: '',
      password: '',
      response: '',
      titulo: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].loginNameProject
    };
  },

  methods: {
    signIn: function signIn() {
      var _this = this;

      this.toggleLoading();
      __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().signInWithEmailAndPassword(this.email, this.password).then(function (resposta) {
        _this.toggleLoading();

        _this.$store.commit('SET_TOKEN', resposta.user.refreshToken);

        _this.$store.commit('SET_USER', __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser);

        _this.$router.push('/');
      }, function (err) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.toggleLoading();
        alert(err.message);
      });
    },
    track: function track() {
      this.$ga.page('/login');
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  }
});

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(312);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  data: function data(router) {
    return {
      section: 'Logout',
      loading: '',
      password: '',
      response: '',
      email: ''
    };
  },
  mounted: function mounted() {
    this.signOut();
  },

  methods: {
    signOut: function signOut() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["a" /* default */].auth().signOut().then(function (resposta) {
        _this.$store.commit('SET_TOKEN', null);
        _this.$store.commit('SET_USER', null);
        window.localStorage.setItem('token', null);
        window.localStorage.setItem('user', null);
        _this.$router.push('/login');
      });
    }
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashFooter',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessagesMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotificationsMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TasksMenu__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TasksMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TasksMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserMenu__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserMenu__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashHeader',
  components: {
    MessagesMenu: __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default.a,
    NotificationsMenu: __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu___default.a,
    TasksMenu: __WEBPACK_IMPORTED_MODULE_4__TasksMenu___default.a,
    UserMenu: __WEBPACK_IMPORTED_MODULE_5__UserMenu___default.a
  },
  props: ['user'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageItem',
  props: ['message']
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessageItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(34);








var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessagesMenu',
  components: {
    MessageItem: __WEBPACK_IMPORTED_MODULE_2__MessageItem___default.a
  },
  firebase: {
    registros: db.ref('sd032021')
  },
  data: function data() {
    return {
      idioma: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].idioma,
      registros: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    Falhas: function Falhas() {
      var arrayFalhas = [];
      this.registros.forEach(function (element) {
        if (element.is_alarme && element.valor !== 0) {
          arrayFalhas.push(element);
        }
      });
      return arrayFalhas;
    },
    qtfFalhas: function qtfFalhas() {
      return this.Falhas.length;
    }
  })
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    notification: {
      type: Object,
      required: true
    }
  }
});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotificationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_filters__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotificationsMenu',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue2_filters___default.a.mixin],
  components: {
    NotificationItem: __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default.a
  },
  data: function data() {
    return {
      tab: 'new'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    newNotifications: function newNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      });
    },
    oldNotifications: function oldNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return n.readAt;
      });
    }
  }),
  methods: {
    markAllAsRead: function markAllAsRead() {
      event.stopPropagation();

      this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      }).forEach(function (notification) {
        notification.readAt = new Date().toUTCString;
      });
    },
    switchTab: function switchTab(event, tab) {
      event.stopPropagation();

      this.tab = tab;
    }
  }
});

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(34);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  data: function data() {
    return {
      titulo: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].sideNameProject
    };
  },
  props: ['user'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(34);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarMenu',
  data: function data() {
    return {
      idioma: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].idioma
    };
  }
});

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(64);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TasksMenu',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserMenu',
  props: ['user']
});

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_CategoriaIndicadores__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_CategoriaIndicadores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_CategoriaIndicadores__);








var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue2_filters___default.a.mixin],
  components: {
    'va-chart': __WEBPACK_IMPORTED_MODULE_3__widgets_VAChart___default.a,
    'categoria-indicadores': __WEBPACK_IMPORTED_MODULE_4__widgets_CategoriaIndicadores___default.a
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].exibirGraficoInicial) {
      this.efetuarPesquisa();
    }
  },

  methods: {
    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.pesquisa.parametro = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].grafico.parametro;
      this.pesquisa.titulo = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].grafico.titulo;
      this.pesquisa.label = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].grafico.label;
      this.$store.dispatch('createGraficoSeteDias', this.pesquisa).then(function (response) {
        _this.seteDiasGrafico = response.data.grafico;
        _this.tituloGrafico = response.data.titulo;
        _this.exibirGrafico = true;
      }).catch(function (e) {
        _this.errors.push(e);
      });
    }
  },
  data: function data() {
    return {
      registros: [],
      idioma: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].idioma,
      pesquisa: {
        titulo: '',
        parametro: '',
        label: ''
      },
      tituloGrafico: '',
      seteDiasGrafico: {},
      exibirGrafico: false,
      categorias: {
        indicadoresGerais: ['BiodigestorNivel', 'BiodigestorPressao', 'BiodigestorTempBio', 'ReceptorNivel', 'ReceptorTemperatura'],
        indicadoresBiologicos: ['BiodigestorQualidadeFosTac', 'BiodigestorQualidadePh', 'ReceptorQualidadeFosTac', 'ReceptorQualidadePh'],
        indicadoresBiogasAwiteBiodigestor: ['AwitePt1Metano', 'AwitePt1CO2', 'AwitePt1H2S', 'AwitePt1O2'],
        indicadoresBiogasAwiteLagoa: ['AwitePt2Metano', 'AwitePt2CO2', 'AwitePt2H2S', 'AwitePt2O2'],
        indicadoresAwite: ['AwitePt5TempAwiFlow', 'AwitePt5AbsHumidityAwiFlow', 'AwitePt5CurrentFlowUncompensated', 'AwitePt5CurrentFlowCompensated', 'AwitePt5VolumeCounter', 'AwitePt5CurrentCalorificValue', 'AwitePt5AverageCalorificValue', 'AwitePt5CurrentEnergyFlow', 'AwitePt5EnergyCounter', 'AwitePt5VolumeCounterDay'],
        indicadoresBiogasAwitePontoConsumo: ['AwitePt3Metano', 'AwitePt3CO2', 'AwitePt3H2S', 'AwitePt3O2']
      }
    };
  },

  firebase: {
    registros: db.ref(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].project)
  }
});

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(34);









var db = __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__["a" /* firebaseApp */].database();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Relatorios',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default.a,
    'va-chart-csv': __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv___default.a
  },
  firebase: {
    registros: db.ref(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].project)
  },
  mounted: function mounted() {},

  computed: {
    acumuladosGrafico: function acumuladosGrafico() {
      var temp = this.$store.state.Relatorios.acumulados.grafico;
      temp.fileName = 'GraficoAcumulados_' + this.pesquisa.parametro + '.csv';
      temp.customHeader = this.pesquisa.cabecalho;
      return temp;
    },
    nomeArquivo: function nomeArquivo() {
      return 'acumulados_' + this.pesquisa.parametro + '_Grafico.csv';
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["en"],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["es"],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["de"],
      idioma: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].idioma,
      registros: [],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: '',
        cabecalho: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Não pode ter data vazia';
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Data final não pode ser anterior à data inicial';
      } else if (this.parametro === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar um parâmetro de pesquisa';
      } else {
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro[0];
        this.pesquisa.label = this.parametro[1] + '(' + this.parametro[2] + ')';
        this.pesquisa.cabecalho = ['Data/Hora', this.parametro[1] + '(' + this.parametro[2] + ')'];
        this.$store.dispatch('createGraficoAcumulados', this.pesquisa).then(function (response) {
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(34);









var db = __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__["a" /* firebaseApp */].database();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Relatorios',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default.a,
    'va-chart-csv': __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv___default.a
  },
  firebase: {
    registros: db.ref(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].project)
  },
  mounted: function mounted() {},

  computed: {
    geraisGrafico: function geraisGrafico() {
      var temp = this.$store.state.Relatorios.gerais;
      temp.fileName = 'GraficoGerais_' + this.pesquisa.parametro + '.csv';
      temp.customHeader = this.pesquisa.cabecalho;
      return temp;
    },
    nomeArquivo: function nomeArquivo() {
      return 'gerais_' + this.pesquisa.parametro + '_Grafico.csv';
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["en"],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["es"],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["de"],
      idioma: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].idioma,
      registros: [],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: '',
        cabecalho: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },

    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Não pode ter data vazia';
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Data final não pode ser anterior à data inicial';
      } else if (this.parametro === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar um parâmetro de pesquisa';
      } else {
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro[0];
        this.pesquisa.label = this.parametro[1] + '(' + this.parametro[2] + ')';
        this.pesquisa.cabecalho = ['Data/Hora', this.parametro[1] + '(' + this.parametro[2] + ')'];
        this.$store.dispatch('createGraficoGerais', this.pesquisa).then(function (response) {
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(34);









var db = __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__["a" /* firebaseApp */].database();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GraficosMaterial',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__widgets_VAChart___default.a,
    'va-chart-csv': __WEBPACK_IMPORTED_MODULE_3__widgets_VAChartCsv___default.a
  },
  firebase: {
    registros: db.ref(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].project)
  },
  mounted: function mounted() {},

  computed: {
    materiaisGrafico: function materiaisGrafico() {
      var temp = this.$store.state.Relatorios.material;
      temp.fileName = 'GraficoMaterial_' + this.pesquisa.parametro + '.csv';
      temp.customHeader = this.pesquisa.cabecalho;
      return temp;
    },
    nomeArquivo: function nomeArquivo() {
      return 'materiais_' + this.pesquisa.parametro + '_Grafico.csv';
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["en"],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["es"],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["de"],
      idioma: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].idioma,
      registros: [],
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: '',
        cabecalho: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa() {
      var _this = this;

      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Não pode ter data vazia';
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Data final não pode ser anterior à data inicial';
      } else if (this.parametro === '') {
        this.showDismissibleAlert = true;
        this.messageAlert = 'Favor selecionar um parâmetro de pesquisa';
      } else {
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro[0];
        this.pesquisa.label = this.parametro[1] + '(' + this.parametro[2] + ')';
        this.pesquisa.cabecalho = ['Data/Hora', this.parametro[1] + '(' + this.parametro[2] + ')'];
        this.$store.dispatch('createGraficoMateriais', this.pesquisa).then(function (response) {
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(34);






var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      registros: [],
      paginate: ['dados'],
      idioma: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].idioma
    };
  },

  firebase: {
    registros: db.ref(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].project)
  }
});

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(34);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usuario',
  mounted: function mounted() {
    this.buscarUsuario();
  },
  data: function data() {
    return {
      idioma: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].idioma,
      displayNameNew: ''
    };
  },

  methods: {
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    buscarUsuario: function buscarUsuario() {
      this.displayNameNew = this.$store.state.user.displayName;
    },
    alterarNomeUsuario: function alterarNomeUsuario() {
      var user = __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser;
      var confirmar = user.updateProfile({
        displayName: this.displayNameNew
      }).then(function () {
        this.$store.commit('SET_USER', __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser);
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser));
        return true;
      }).catch(function (error) {
        console.log(error);
        return false;
      });
      if (confirmar) {
        this.showAlert('Nome alterado com sucesso!', 'Favor logar novamente para as alterações serem exibidas!', 'info', true, 'Ok');
      } else {
        this.showAlert('Solicitação não atendida!', 'Falha ao alterar o nome!', 'warning', true, 'Ok');
      }
    },
    alterarSenhaUsuario: function alterarSenhaUsuario() {
      var auth = __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth();
      var emailAddress = this.$store.state.user.email;
      var confirmar = auth.sendPasswordResetEmail(emailAddress).then(function () {
        return true;
      }).catch(function (error) {
        console.log(error);
        return false;
      });
      if (confirmar) {
        this.showAlert('Solicitação efetuada com Sucesso!', 'Email de redefinição de senha enviado para ' + emailAddress, 'info', true, 'Ok');
      } else {
        this.showAlert('Solicitação não atendida!', 'Falha ao enviar email de redefinição de senha para  ' + emailAddress, 'warning', true, 'Ok');
      }
    }
  }
});

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_filters__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_filters__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CategoriaIndicadores',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue2_filters___default.a.mixin],
  props: {
    titulo: { type: String, required: true },
    ids: { type: Array, required: true },
    registros: { type: Array, required: true },
    idioma: { type: String, required: true }
  },
  computed: {
    listaFiltrada: function listaFiltrada() {
      var _this = this;

      return this.registros.filter(function (r) {
        return _this.ids.includes(r.campo) && r.exibir;
      });
    }
  }
});

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_exportCsvChart_js__ = __webpack_require__(160);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chart',
  props: {
    'chart-config': {
      type: Object,
      validator: function validator(value) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
        if (!keys.includes('type')) {
          console.error('[Chart.js] Object must has type (key)');
          return false;
        }
        if (!keys.includes('data')) {
          console.error('[Chart.js] Object must has data (key)');
          return false;
        }
        return true;
      }
    }
  },
  mounted: function mounted() {
    var chartCanvas = this.$el.getContext('2d');
    var chartConfig = this.chartConfig;
    new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(chartCanvas, chartConfig);
  },

  methods: {
    baixarCsv: function baixarCsv() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_exportCsvChart_js__["a" /* exportChartConfigToCsv */])(this.chartConfig, 'grafico.csv');
    }
  }
});

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_exportCsvChart_js__ = __webpack_require__(160);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chart',
  props: {
    chartConfig: {
      type: Object,
      validator: function validator(value) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
        if (!keys.includes('type')) {
          console.error('[Chart.js] Object must has type (key)');
          return false;
        }
        if (!keys.includes('data')) {
          console.error('[Chart.js] Object must has data (key)');
          return false;
        }
        return true;
      }
    },
    delimiter: {
      type: String,
      default: ';'
    }
  },
  mounted: function mounted() {},

  methods: {
    baixarCsv: function baixarCsv() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_exportCsvChart_js__["a" /* exportChartConfigToCsv */])(this.chartConfig, this.chartConfig.fileName, this.delimiter, this.chartConfig.customHeader);
    }
  }
});

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 314,
	"./af.js": 314,
	"./ar": 321,
	"./ar-dz": 315,
	"./ar-dz.js": 315,
	"./ar-kw": 316,
	"./ar-kw.js": 316,
	"./ar-ly": 317,
	"./ar-ly.js": 317,
	"./ar-ma": 318,
	"./ar-ma.js": 318,
	"./ar-sa": 319,
	"./ar-sa.js": 319,
	"./ar-tn": 320,
	"./ar-tn.js": 320,
	"./ar.js": 321,
	"./az": 322,
	"./az.js": 322,
	"./be": 323,
	"./be.js": 323,
	"./bg": 324,
	"./bg.js": 324,
	"./bm": 325,
	"./bm.js": 325,
	"./bn": 326,
	"./bn.js": 326,
	"./bo": 327,
	"./bo.js": 327,
	"./br": 328,
	"./br.js": 328,
	"./bs": 329,
	"./bs.js": 329,
	"./ca": 330,
	"./ca.js": 330,
	"./cs": 331,
	"./cs.js": 331,
	"./cv": 332,
	"./cv.js": 332,
	"./cy": 333,
	"./cy.js": 333,
	"./da": 334,
	"./da.js": 334,
	"./de": 337,
	"./de-at": 335,
	"./de-at.js": 335,
	"./de-ch": 336,
	"./de-ch.js": 336,
	"./de.js": 337,
	"./dv": 338,
	"./dv.js": 338,
	"./el": 339,
	"./el.js": 339,
	"./en-au": 340,
	"./en-au.js": 340,
	"./en-ca": 341,
	"./en-ca.js": 341,
	"./en-gb": 342,
	"./en-gb.js": 342,
	"./en-ie": 343,
	"./en-ie.js": 343,
	"./en-nz": 344,
	"./en-nz.js": 344,
	"./eo": 345,
	"./eo.js": 345,
	"./es": 348,
	"./es-do": 346,
	"./es-do.js": 346,
	"./es-us": 347,
	"./es-us.js": 347,
	"./es.js": 348,
	"./et": 349,
	"./et.js": 349,
	"./eu": 350,
	"./eu.js": 350,
	"./fa": 351,
	"./fa.js": 351,
	"./fi": 352,
	"./fi.js": 352,
	"./fo": 353,
	"./fo.js": 353,
	"./fr": 356,
	"./fr-ca": 354,
	"./fr-ca.js": 354,
	"./fr-ch": 355,
	"./fr-ch.js": 355,
	"./fr.js": 356,
	"./fy": 357,
	"./fy.js": 357,
	"./gd": 358,
	"./gd.js": 358,
	"./gl": 359,
	"./gl.js": 359,
	"./gom-latn": 360,
	"./gom-latn.js": 360,
	"./gu": 361,
	"./gu.js": 361,
	"./he": 362,
	"./he.js": 362,
	"./hi": 363,
	"./hi.js": 363,
	"./hr": 364,
	"./hr.js": 364,
	"./hu": 365,
	"./hu.js": 365,
	"./hy-am": 366,
	"./hy-am.js": 366,
	"./id": 367,
	"./id.js": 367,
	"./is": 368,
	"./is.js": 368,
	"./it": 369,
	"./it.js": 369,
	"./ja": 370,
	"./ja.js": 370,
	"./jv": 371,
	"./jv.js": 371,
	"./ka": 372,
	"./ka.js": 372,
	"./kk": 373,
	"./kk.js": 373,
	"./km": 374,
	"./km.js": 374,
	"./kn": 375,
	"./kn.js": 375,
	"./ko": 376,
	"./ko.js": 376,
	"./ky": 377,
	"./ky.js": 377,
	"./lb": 378,
	"./lb.js": 378,
	"./lo": 379,
	"./lo.js": 379,
	"./lt": 380,
	"./lt.js": 380,
	"./lv": 381,
	"./lv.js": 381,
	"./me": 382,
	"./me.js": 382,
	"./mi": 383,
	"./mi.js": 383,
	"./mk": 384,
	"./mk.js": 384,
	"./ml": 385,
	"./ml.js": 385,
	"./mr": 386,
	"./mr.js": 386,
	"./ms": 388,
	"./ms-my": 387,
	"./ms-my.js": 387,
	"./ms.js": 388,
	"./mt": 389,
	"./mt.js": 389,
	"./my": 390,
	"./my.js": 390,
	"./nb": 391,
	"./nb.js": 391,
	"./ne": 392,
	"./ne.js": 392,
	"./nl": 394,
	"./nl-be": 393,
	"./nl-be.js": 393,
	"./nl.js": 394,
	"./nn": 395,
	"./nn.js": 395,
	"./pa-in": 396,
	"./pa-in.js": 396,
	"./pl": 397,
	"./pl.js": 397,
	"./pt": 399,
	"./pt-br": 398,
	"./pt-br.js": 398,
	"./pt.js": 399,
	"./ro": 400,
	"./ro.js": 400,
	"./ru": 401,
	"./ru.js": 401,
	"./sd": 402,
	"./sd.js": 402,
	"./se": 403,
	"./se.js": 403,
	"./si": 404,
	"./si.js": 404,
	"./sk": 405,
	"./sk.js": 405,
	"./sl": 406,
	"./sl.js": 406,
	"./sq": 407,
	"./sq.js": 407,
	"./sr": 409,
	"./sr-cyrl": 408,
	"./sr-cyrl.js": 408,
	"./sr.js": 409,
	"./ss": 410,
	"./ss.js": 410,
	"./sv": 411,
	"./sv.js": 411,
	"./sw": 412,
	"./sw.js": 412,
	"./ta": 413,
	"./ta.js": 413,
	"./te": 414,
	"./te.js": 414,
	"./tet": 415,
	"./tet.js": 415,
	"./th": 416,
	"./th.js": 416,
	"./tl-ph": 417,
	"./tl-ph.js": 417,
	"./tlh": 418,
	"./tlh.js": 418,
	"./tr": 419,
	"./tr.js": 419,
	"./tzl": 420,
	"./tzl.js": 420,
	"./tzm": 422,
	"./tzm-latn": 421,
	"./tzm-latn.js": 421,
	"./tzm.js": 422,
	"./uk": 423,
	"./uk.js": 423,
	"./ur": 424,
	"./ur.js": 424,
	"./uz": 426,
	"./uz-latn": 425,
	"./uz-latn.js": 425,
	"./uz.js": 426,
	"./vi": 427,
	"./vi.js": 427,
	"./x-pseudo": 428,
	"./x-pseudo.js": 428,
	"./yo": 429,
	"./yo.js": 429,
	"./zh-cn": 430,
	"./zh-cn.js": 430,
	"./zh-hk": 431,
	"./zh-hk.js": 431,
	"./zh-tw": 432,
	"./zh-tw.js": 432
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637;

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(685),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(684),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  "data-v-0fcc4b82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(683),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  "data-v-3198abf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(687),
  /* scopeId */
  "data-v-f6aac0a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(680),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(669),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(681),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(621)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(686),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(618)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(682),
  /* scopeId */
  "data-v-58672dc7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.idioma === 'DE') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ein/Aus")]) : (_vm.idioma === 'EN') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("On/Off")]) : (_vm.idioma === 'ES') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Encendido / Apagado")]) : _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ligado/Desligado")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [(_vm.idioma === 'DE') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'EN') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'ES') ? _c('th', [_vm._v("Variable")]) : _c('th', [_vm._v("Variável")]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Werte")]) : (_vm.idioma === 'EN') ? _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Values")]) : (_vm.idioma === 'ES') ? _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Valor")]) : _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelDe')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0) : (_vm.idioma === 'EN') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEn')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0) : (_vm.idioma === 'ES') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEs')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0) : _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelPtBr')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "badge"
    }, [_vm._v("Off")])])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.idioma === 'DE') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Werte")]) : (_vm.idioma === 'EN') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Values")]) : (_vm.idioma === 'ES') ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Valores")]) : _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Valores")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [(_vm.idioma === 'DE') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'EN') ? _c('th', [_vm._v("Variable")]) : (_vm.idioma === 'ES') ? _c('th', [_vm._v("Variable")]) : _c('th', [_vm._v("Variável")]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Werte")]) : (_vm.idioma === 'EN') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Values")]) : (_vm.idioma === 'ES') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]) : _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelDe')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0) : (_vm.idioma === 'EN') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelEn')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0) : (_vm.idioma === 'ES') ? _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelEs')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0) : _c('tbody', _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, false, 'is_bool'), 'labelPtBr')), function(registro) {
    return _c('tr', {
      key: registro.id
    }, [_c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                      " + _vm._s(parseFloat(registro.valor).toFixed(1)) + " " + _vm._s(registro.unidade_medida) + "\n                     ")])])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.message.labelPtBr))]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message.createdAt))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message.body))])])])
},staticRenderFns: []}

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n  "), _c('a', {
    attrs: {
      "href": "https://www.solidtectecnologia.com.br"
    }
  }, [_vm._v("Solidtec Tecnologia - +55(47) 3635-1755")]), _vm._v(".")]), _vm._v(" Todos os direitos reservados.\n")])
},staticRenderFns: []}

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    on: {
      "click": _vm.baixarCsv
    }
  }, [_vm._v("Exportar CSV")])
},staticRenderFns: []}

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n   " + _vm._s(_vm.messageAlert) + "\n ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart-csv', {
    attrs: {
      "chart-config": _vm.geraisGrafico
    }
  }), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.geraisGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Anforderungen an die Suche")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Zeitverlauf")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Anfangsdatum")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.de,
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Letzter Termin")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.de,
      "placeholder": "Enddatum auswählen",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Search requirements")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Time course")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.en,
      "placeholder": "Select start date",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.en,
      "placeholder": "Select end date",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Curso del tiempo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("La fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.es,
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.es,
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Período")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parameter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), false, 'is_acumulador'), 'labelDe')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelDe, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelDe))])
  })], 2)]), _vm._v(" "), _c('br')]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parameter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), false, 'is_acumulador'), 'labelEn')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEn, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEn))])
  })], 2)]), _vm._v(" "), _c('br')]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parámetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), false, 'is_acumulador'), 'labelEs')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEs, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')]) : _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parâmetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o Parâmetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), false, 'is_acumulador'), 'labelPtBr')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelPtBr, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelPtBr))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [(_vm.idioma === 'DE') ? _c('span', [_vm._v("Forschung durchführen")]) : (_vm.idioma === 'EN') ? _c('span', [_vm._v("Conduct Search")]) : (_vm.idioma === 'ES') ? _c('span', [_vm._v("Realizar búsqueda")]) : _c('span', [_vm._v("Efetuar Pesquisa")])])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores gerais dos reatores",
      "ids": _vm.categorias.indicadoresGerais,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores biológicos",
      "ids": _vm.categorias.indicadoresBiologicos,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores Awite",
      "ids": _vm.categorias.indicadoresAwite,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores do biogás no Biodigestor (Sistema Awite)",
      "ids": _vm.categorias.indicadoresBiogasAwiteBiodigestor,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores do biogás na Lagoa (Sistema Awite)",
      "ids": _vm.categorias.indicadoresBiogasAwiteLagoa,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  }), _vm._v(" "), _c('categoria-indicadores', {
    attrs: {
      "titulo": "Indicadores do biogás no Ponto de Consumo (Sistema Awite)",
      "ids": _vm.categorias.indicadoresBiogasAwitePontoConsumo,
      "registros": _vm.registros,
      "idioma": _vm.idioma
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "notification-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.notification.title))]), _vm._v(" "), _c('small', {
    staticClass: "time pull-right"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notification.createdAt))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.notification.body))])])])
},staticRenderFns: []}

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('messages-menu'), _vm._v(" "), _c('user-menu', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "/static/img/bi-logo-archea-biogas2.svg",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.titulo))])])])]), _vm._v(" "), _c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "id": "searchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "searchContainer"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "row center-block"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("Nutzername")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Datensatzname")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Passwort neu definieren")])])])]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("User name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Save name")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Redefine password")])])])]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("Nombre de usuario")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Guardar nombre")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Redefinir contraseña")])])])]) : _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [_vm._v("Nome do Usuário")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarNomeUsuario()
      }
    }
  }, [_vm._v("Gravar Nome")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        return _vm.alterarSenhaUsuario()
      }
    }
  }, [_vm._v("Redefinir Senha")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.idioma === 'DE') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Bereiche")]) : (_vm.idioma === 'EN') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Areas")]) : (_vm.idioma === 'ES') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Áreas")]) : _c('li', {
    staticClass: "header"
  }, [_vm._v("Áreas")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Hauptsächlich")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Home")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/manutencao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-android-settings"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Wartung")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Maintenance")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Mantenimiento")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Manutenção")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa ion-stats-bars"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Grafik")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Graphics")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-gerais"
    }
  }, [_c('a', [(_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Allgemeines")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" General")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" General")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v(" Gerais")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-material"
    }
  }, [_c('a', [(_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v(" Material")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-acumulados"
    }
  }, [_c('a', [(_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Kumuliert pro Tag")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Accumulated per day")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v(" Acumulado por día")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v(" Acumulados por dia")])])])], 1)])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/usuario"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Nutzer")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("User")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuario")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuário")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), (_vm.idioma === 'DE') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Ausgehen")]) : (_vm.idioma === 'EN') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Exit")]) : (_vm.idioma === 'ES') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Salir")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Sair")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])
}]}

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _vm._l((_vm.user.roles), function(role) {
    return _c('small', {
      key: role
    }, [_vm._v(_vm._s(role))])
  })], 2)]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "user-footer"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat btn-block",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])])])
}]}

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n              Design some buttons\n              "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
}]}

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n   " + _vm._s(_vm.messageAlert) + "\n ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart-csv', {
    attrs: {
      "chart-config": _vm.acumuladosGrafico
    }
  }), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.acumuladosGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Anforderungen an die Suche")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Zeitverlauf")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Anfangsdatum")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.de,
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Letzter Termin")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.de,
      "placeholder": "Enddatum auswählen",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Search requirements")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Time course")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.en,
      "placeholder": "Select start date",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.en,
      "placeholder": "Select end date",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Curso del tiempo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("La fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.es,
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.es,
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Período")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parameter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), true, 'is_acumulador'), 'labelDe')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelDe, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelDe))])
  })], 2)]), _vm._v(" "), _c('br')]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parameter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), true, 'is_acumulador'), 'labelEn')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEn, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEn))])
  })], 2)]), _vm._v(" "), _c('br')]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parámetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), true, 'is_acumulador'), 'labelEs')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEs, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')]) : _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parâmetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o Parâmetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'registrado'), true, 'is_acumulador'), 'labelPtBr')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelPtBr, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelPtBr))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row categoria-indicadores"
  }, [_c('h3', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.listaFiltrada, 'label')), function(registro) {
    return _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [(_vm.idioma === 'DE') ? _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelDe))]) : (_vm.idioma === 'EN') ? _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelEn))]) : (_vm.idioma === 'ES') ? _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelEs))]) : _c('span', {
      staticClass: "info-box-text-legenda"
    }, [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + "\n          "), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n          " + _vm._s(registro.data_atualizacao) + "\n        ")])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
}]}

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.qtfFalhas))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.idioma === 'DE') ? _c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.qtfFalhas) + " Fehler wurden identifiziert")]) : (_vm.idioma === 'EN') ? _c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.qtfFalhas) + " fault(s) were identified")]) : (_vm.idioma === 'ES') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Se identificaron " + _vm._s(_vm.qtfFalhas) + " fallas")]) : _c('li', {
    staticClass: "header"
  }, [_vm._v("Foram identificadas " + _vm._s(_vm.qtfFalhas) + " falha(s)")]), _vm._v(" "), (_vm.Falhas.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.Falhas), function(message, key) {
    return _c('message-item', {
      key: key,
      attrs: {
        "message": message
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [(_vm.idioma === 'DE') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Nah dran")]) : (_vm.idioma === 'EN') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Close")]) : (_vm.idioma === 'ES') ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Cerrar")]) : _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Fechar")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/system128.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("\n       " + _vm._s(_vm.titulo) + "\n     ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signIn.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Digite seu email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Digite sua senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', {
    staticClass: "vertical-5p lead"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(_vm.idioma === 'DE') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.nameDe.toUpper) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionDe))])]) : (_vm.idioma === 'EN') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.nameEn) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEn))])]) : (_vm.idioma === 'ES') ? _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.nameEs) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEs))])]) : _c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.meta.namePtBr) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionPtBr))])]), _vm._v(" "), (_vm.idioma === 'DE') ? _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.nameDe))])]) : (_vm.idioma === 'EN') ? _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.nameEn))])]) : (_vm.idioma === 'ES') ? _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.nameEs))])]) : _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.namePtBr))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Hauptsächlich")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Principal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Principal")])])
}]}

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n   " + _vm._s(_vm.messageAlert) + "\n ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart-csv', {
    attrs: {
      "chart-config": _vm.materiaisGrafico
    }
  }), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.materiaisGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Anforderungen an die Suche")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Zeitverlauf")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Anfangsdatum")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.de,
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Letzter Termin")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.de,
      "placeholder": "Enddatum auswählen",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Search requirements")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Time course")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.en,
      "placeholder": "Select start date",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.en,
      "placeholder": "Select end date",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Curso del tiempo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("La fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.es,
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.es,
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]) : _c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Período")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.idioma === 'DE') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parameter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_qualidade'), 'labelDe')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelDe, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelDe))])
  })], 2)]), _vm._v(" "), _c('br')]) : (_vm.idioma === 'EN') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parameter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_qualidade'), 'labelEn')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEn, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEn))])
  })], 2)]), _vm._v(" "), _c('br')]) : (_vm.idioma === 'ES') ? _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parámetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_qualidade'), 'labelEs')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelEs, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')]) : _c('div', {
    staticClass: "input-group"
  }, [_c('h4', [_vm._v("Parâmetro")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o Parâmetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_qualidade'), 'labelPtBr')), function(registro, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": [registro['.key'], registro.labelPtBr, registro.unidade_medida]
      }
    }, [_vm._v(_vm._s(registro.labelPtBr))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [(_vm.idioma === 'DE') ? _c('span', [_vm._v("Forschung durchführen")]) : (_vm.idioma === 'EN') ? _c('span', [_vm._v("Conduct Search")]) : (_vm.idioma === 'ES') ? _c('span', [_vm._v("Realizar búsqueda")]) : _c('span', [_vm._v("Efetuar Pesquisa")])])])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.newNotifications)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    class: {
      active: _vm.tab === 'new'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab($event, 'new')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    class: {
      active: _vm.tab === 'old'
    },
    on: {
      "click": function($event) {
        return _vm.switchTab($event, 'old')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Old")])])])]), _vm._v(" "), _c('li', [(_vm.tab === 'new') ? _c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.newNotifications), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    })
  }), _vm._v(" "), (!_vm.newNotifications.length) ? _c('li', [_c('span', {
    staticClass: "center-block text-center"
  }, [_vm._v("There are no new notifications")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.tab === 'old') ? _c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.oldNotifications), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    })
  }), _vm._v(" "), (!_vm.oldNotifications.length) ? _c('li', [_c('span', {
    staticClass: "center-block text-center"
  }, [_vm._v("There are no old notifications")])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.newNotifications.length && _vm.tab === 'new') ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.markAllAsRead
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Mark all as read")])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Relatorios.js": 479,
	"./index.js": 161
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 691;

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[477]);


// WEBPACK FOOTER //
// static/js/app.21947b8824a5ec7d4dad.js